import { render, staticRenderFns } from "./ExaminList.vue?vue&type=template&id=0b373652&scoped=true&"
import script from "./ExaminList.vue?vue&type=script&lang=js&"
export * from "./ExaminList.vue?vue&type=script&lang=js&"
import style0 from "./ExaminList.vue?vue&type=style&index=0&id=0b373652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b373652",
  null
  
)

export default component.exports